var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCraousalRating = function SvgCraousalRating(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 920 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "craousal_rating_svg__a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8d909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.058,
    stopColor: "#ebd60c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.264,
    stopColor: "#ffc41e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#fcab00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711,
    stopColor: "#fba00d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fa8e21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "craousal_rating_svg__c",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#afc82a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402,
    stopColor: "#c0cd1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8d909"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "craousal_rating_svg__b",
    width: 230.353,
    height: 231.08,
    x: 345.508,
    y: 239.645,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 13.5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.271
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58416"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1957"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#cfcfce",
    stroke: "#b2b2b2",
    "data-name": "Rectangle 30145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 920,
    height: 251.365,
    stroke: "none",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 919,
    height: 250.365,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 0.5
  })), /*#__PURE__*/React.createElement("text", {
    fill: "#42424f",
    "data-name": "Statement 1",
    fontFamily: "Arial-BoldMT, Arial",
    fontSize: 47,
    fontWeight: 700,
    transform: "translate(319.114 133.354)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Statement 1"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6750"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "highly disgree emoji"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6748",
    transform: "translate(55.962 279.165)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.457,
    cy: 63.766,
    fill: "#f54f4f",
    "data-name": "face",
    rx: 63.457,
    ry: 63.766
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "right eye",
    transform: "translate(22.403 45.102)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.495,
    cy: 12.552,
    fill: "#42424f",
    "data-name": "Ellipse 3",
    rx: 7.495,
    ry: 12.552,
    transform: "translate(10.574 11.132)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#42424f",
    strokeLinecap: "round",
    strokeWidth: 10,
    d: "M0 .051s10.005-.6 17.658 2.285a35.15 35.15 0 0 1 12.954 9.245",
    "data-name": "Path 6"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#42424f",
    d: "M62.847 89.411c13.632 0 24.883 12.37 24.883 16.008s-11.251-2.835-24.883-2.835-24.433 5.527-24.433 1.893 10.802-15.066 24.433-15.066"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "left eye",
    transform: "translate(75.66 45.308)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.091,
    cy: 11.938,
    fill: "#42424f",
    "data-name": "Ellipse 3",
    rx: 8.091,
    ry: 11.938,
    transform: "translate(2.56 11.582)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#42424f",
    strokeLinecap: "round",
    strokeWidth: 10,
    d: "M30.612.051s-10.005-.6-17.658 2.285A35.15 35.15 0 0 0 0 11.581",
    "data-name": "Path 6"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "disagree emoji"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#craousal_rating_svg__a)",
    d: "M63.069 0A63.376 63.376 0 1 1 0 63.376 63.223 63.223 0 0 1 63.069 0",
    "data-name": "face",
    transform: "translate(221.179 280.254)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "right eye",
    transform: "translate(253.631 332.954)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.512,
    cy: 12.053,
    fill: "#42424f",
    "data-name": "Ellipse 3",
    rx: 8.512,
    ry: 12.053
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "right eye",
    transform: "translate(298.532 333.28)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.142,
    cy: 12.013,
    fill: "#42424f",
    "data-name": "Ellipse 3",
    rx: 8.142,
    ry: 12.013
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#42424f",
    d: "M285.066 371.222c12.294 0 22.4 8.569 22.4 9.942s-10.1-3.452-22.4-3.452-21.848 4.824-21.848 3.451 9.554-9.941 21.848-9.941",
    "data-name": "Path 7"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "nuteral emoji"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#craousal_rating_svg__b)",
    transform: "translate(-.002 .005)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e8d909",
    d: "M460.686 270.14c41.243 0 74.676 33.6 74.676 75.04s-33.434 75.04-74.676 75.04-74.676-33.597-74.676-75.04 33.434-75.04 74.676-75.04",
    "data-name": "face"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#42424f",
    stroke: "#707070",
    "data-name": "Ellipse 4",
    transform: "translate(419.371 327.859)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.126,
    cy: 14.801,
    stroke: "none",
    rx: 10.126,
    ry: 14.801
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.126,
    cy: 14.801,
    fill: "none",
    rx: 9.626,
    ry: 14.301
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#42424f",
    stroke: "#707070",
    "data-name": "Ellipse 5",
    transform: "translate(481.4 327.859)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.666,
    cy: 14.801,
    stroke: "none",
    rx: 9.666,
    ry: 14.801
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.666,
    cy: 14.801,
    fill: "none",
    rx: 9.166,
    ry: 14.301
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#42424f",
    stroke: "#707070",
    "data-name": "Ellipse 8",
    transform: "translate(429.211 383.295)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.299,
    cy: 2.775,
    stroke: "none",
    rx: 31.299,
    ry: 2.775
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.299,
    cy: 2.775,
    fill: "none",
    rx: 30.799,
    ry: 2.275
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "agred emoji",
    transform: "translate(574.053 280.254)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#craousal_rating_svg__c)",
    d: "M63.069 0A63.376 63.376 0 1 1 0 63.376 63.223 63.223 0 0 1 63.069 0",
    "data-name": "face"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.245,
    cy: 12.013,
    fill: "#42424f",
    "data-name": "Ellipse 6",
    rx: 8.245,
    ry: 12.013,
    transform: "translate(28.952 49.283)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.039,
    cy: 12.013,
    fill: "#42424f",
    "data-name": "Ellipse 7",
    rx: 8.039,
    ry: 12.013,
    transform: "translate(81.108 49.283)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42424f",
    d: "M63.302 95.797c14.476 0 26.832-7.363 26.832-3.734s-12.356 16.876-26.832 16.876-25.934-13.247-25.934-16.876 11.459 3.734 25.934 3.734",
    "data-name": "Path 14"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "highly agreed emoji"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6749"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#59ba46",
    d: "M801.952 280.254a63.376 63.376 0 1 1-63.069 63.376 63.223 63.223 0 0 1 63.069-63.376",
    "data-name": "face"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42424f",
    d: "M781.224 327.397c7.4 0 13.4 5.286 13.4 11.806s-6-2.856-13.4-2.856-13.4 9.376-13.4 2.856 6-11.806 13.4-11.806",
    "data-name": "Path 9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42424f",
    d: "M822.523 327.397c7.4 0 13.4 5.286 13.4 11.806s-6-2.856-13.4-2.856-13.4 9.376-13.4 2.856 6-11.806 13.4-11.806",
    "data-name": "Path 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42424f",
    d: "M802.764 362.889c19.352 0 37.513-7.378 37.513 0s-18.161 26.719-37.513 26.719-35.865-19.341-35.865-26.719 16.512 0 35.865 0",
    "data-name": "Path 13"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#42424f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M460.073 438.849a20.27 20.27 0 0 0-14.407 6.027 20.72 20.72 0 0 0 0 29.1 20.233 20.233 0 0 0 28.813 0 20.7 20.7 0 0 0-.007-29.093 20.3 20.3 0 0 0-14.399-6.034m0 38.214a17.38 17.38 0 0 1-12.348-5.166 17.76 17.76 0 0 1 0-24.942 17.34 17.34 0 0 1 24.7 0 17.75 17.75 0 0 1-.005 24.937 17.4 17.4 0 0 1-12.343 5.171Z",
    "data-name": "Path 18212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.439 455.014h-12.495l3.337-3.37a1.48 1.48 0 0 0 .357-1.41 1.46 1.46 0 0 0-1.019-1.029 1.45 1.45 0 0 0-1.4.361l-5.821 5.879a1.48 1.48 0 0 0 0 2.078l5.821 5.879a1.45 1.45 0 0 0 1.4.361 1.46 1.46 0 0 0 1.019-1.029 1.48 1.48 0 0 0-.357-1.41l-3.337-3.37h12.495a4.36 4.36 0 0 1 3.781 2.2 4.45 4.45 0 0 1 0 4.409 4.36 4.36 0 0 1-3.781 2.2h-4.366a1.45 1.45 0 0 0-1.26.735 1.48 1.48 0 0 0 0 1.47 1.45 1.45 0 0 0 1.26.735h4.366a7.26 7.26 0 0 0 6.3-3.674 7.41 7.41 0 0 0 0-7.349 7.26 7.26 0 0 0-6.3-3.666",
    "data-name": "Path 18213"
  })))));
};
export default SvgCraousalRating;